import { render, staticRenderFns } from "./TestCustomer.vue?vue&type=template&id=4afe3ab3&scoped=true"
import script from "./TestCustomer.vue?vue&type=script&lang=js"
export * from "./TestCustomer.vue?vue&type=script&lang=js"
import style0 from "./TestCustomer.vue?vue&type=style&index=0&id=4afe3ab3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe3ab3",
  null
  
)

export default component.exports